module.exports = __webpack_public_path__ + "static/media/slideimage-1.41fbccc5.jpg";